import moment from "moment";
import * as yup from "yup";

const MIN_HEADCOUNT = 1;
const MIN_AVERAGE_AGE = 16;
const MAX_AVERAGE_AGE = 70;

const validation = (messages, { firstOfMonthMessage }) =>
  yup.object().shape({
    demographics: yup.object().shape({
      category: yup.string().nullable().required(messages.REQUIRED_CHOICE),
      headcount: yup
        .number()
        .nullable()
        .typeError(messages.NUMBER)
        .min(MIN_HEADCOUNT, `${messages.MIN} ${MIN_HEADCOUNT}`)
        .required(messages.REQUIRED),
      regime: yup.string().nullable().required(messages.REQUIRED_CHOICE),
      department: yup.string().nullable().required(messages.REQUIRED),
      effectiveDate: yup
        .date()
        .nullable()
        .required(messages.REQUIRED)
        .test("isFirstOfMonth", firstOfMonthMessage, (value) =>
          value ? moment(value).date() === 1 : true,
        ),
      averageAge: yup
        .number()
        .nullable()
        .typeError(messages.NUMBER)
        .min(MIN_AVERAGE_AGE, `${messages.MIN} ${MIN_AVERAGE_AGE}`)
        .max(MAX_AVERAGE_AGE, `${messages.MAX} ${MAX_AVERAGE_AGE}`)
        .required(messages.REQUIRED),
    }),
  });

export default validation;
